import { API } from 'app/utils/client';
import { IProfile } from 'app/models';
import { CRUDService } from './api';

export class ProfileService extends CRUDService<IProfile> { }

const instance = new ProfileService(API, 'v1/profiles');
export default instance;
